<template>
  <div class="create-email-template-form">
    <a-form-model ref="form" :model="formData" :rules="rules" layout="vertical">
      <a-form-model-item label="Şablon Adı" prop="name">
        <a-input v-model="formData.name" />
      </a-form-model-item>
      <a-form-model-item label="Konu" prop="subject">
        <a-input v-model="formData.subject" />
      </a-form-model-item>
      <a-form-model-item label="Kategori" prop="category">
        <a-select v-model="formData.category">
          <a-select-option value="marketing">Pazarlama</a-select-option>
          <a-select-option value="operational">Operasyonel</a-select-option>
          <a-select-option value="private">Özel</a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "CreateEmailTemplateForm",
    data() {
        return {
            formData: {
                name: "",
                subject: "",
                category: undefined,
            },
            rules: {
                name: [{ required: true, message: "Lütfen şablon adını girin" }],
                subject: [{ required: true, message: "Lütfen şablon konusunu girin" }],
                category: [{ required: true, message: "Lütfen şablon kategorisini seçin" }],
            },
        };
    },
    methods: {
        getFormData() {
            return this.formData;
        },
    },
});
</script>

<style scoped lang="scss"></style>
